import { render, staticRenderFns } from "./MostTradedSymbols.vue?vue&type=template&id=083bd402&scoped=true&"
import script from "./MostTradedSymbols.vue?vue&type=script&lang=js&"
export * from "./MostTradedSymbols.vue?vue&type=script&lang=js&"
import style0 from "./MostTradedSymbols.vue?vue&type=style&index=0&id=083bd402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083bd402",
  null
  
)

export default component.exports